import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ListItem } from './ListItem';

export class ListPanel extends React.Component {
  render() {
    const { title, items, onButtonClick, selectedIndex } = this.props;

    return (
      <div className={this.props.wrapperClassName ? this.props.wrapperClassName : "col-md-4 custom-list-wrapper"} data-qa-container={this.props.qaTag}>
        <ul className="list-group custom-list theme">
          <li className="list-group-item list-group-item-top-header">
            <FormattedMessage { ...title } />
            { onButtonClick ?
              <button
                type="button"
                className="btn btn-link d-lg-none align-middle float-end text-white"
                onClick={ onButtonClick }
              >
                <span className="fa-solid fa-pen-to-square"></span>
              </button>
                : null
            }
          </li>
          {
            items.map((item, index) => (
              <ListItem
                key={index}
                index={ index }
                ref={ 'listItem_' + index }
                handleClick={ this.props.handleListItemClick }
                className={ selectedIndex && item.itemId.toString() === selectedIndex.toString() ? 'active' : null }
                { ...item }
              />
            ))
          }
        </ul>
      </div>
    );
  }
}

ListPanel.propTypes = {
  title: PropTypes.object,
  emptyMessage: PropTypes.object,
  items: PropTypes.array,
  selectedIndex: PropTypes.any,
  handleListItemClick: PropTypes.func,
  onButtonClick: PropTypes.func,
  qaTag: PropTypes.string,
  wrapperClassName: PropTypes.string,
};
